// extracted by mini-css-extract-plugin
export var horizontalDivider = "horizontal_divider-module--horizontalDivider--vfEGl";
export var lineWeight_thick = "horizontal_divider-module--lineWeight_thick--B4PQH";
export var lineWeight_thin = "horizontal_divider-module--lineWeight_thin--m9tap";
export var noMargin = "horizontal_divider-module--noMargin--QQeP6";
export var text = "horizontal_divider-module--text--eehcR";